import React, {useCallback, useEffect, useMemo, useState} from "react";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {useLocalStorage} from "@mantine/hooks";
import Axios_base from "../../../axios_base";
import dayjs from "dayjs";


function NumberDisconnectedAlert() {
    const {t} = useTranslation();

    const [lastDisconnectionIgnore, setLastDisconnectionIgnore] = useLocalStorage({
        key: "last-disconnection-ignore",
        defaultValue: "0000-00-00 00:00:00",
    });

    const [lastDisconnection, setLastDisconnection] = useState(null);

    const isOpen = useMemo(() => {
        return lastDisconnection && dayjs(lastDisconnection).isAfter(lastDisconnectionIgnore);
    }, [lastDisconnectionIgnore, lastDisconnection]);

    const onClose = useCallback(() => {
        setLastDisconnectionIgnore(lastDisconnection);
    });

    useEffect(() => (async () => {
        const {data: lastDisconnection} = await Axios_base.get("/number/last-disconnection");
        setLastDisconnection(lastDisconnection?.created_at);
    })(), [lastDisconnectionIgnore]);

    if (!isOpen) {
        return null;
    }

    return (
        <Container>
            <div className="ba-top-alert ba-warning ba-gp-1">
                <div className="ba-content">
                    <span>{t("words.number_disconnected_alert_description")}</span>
                    <Link to="/numbers" className="ba-text-underline">
                        {t("words.number_disconnected_alert_action")}
                    </Link>
                </div>
                <button className="ba-top-alert-close" onClick={onClose}>
                    <CloseIcon/>
                </button>
            </div>
        </Container>
    );
}

const Container = styled.div`
    .ba-top-alert {
        box-sizing: unset;
    }

    .ba-top-alert > .ba-top-alert-close {
        color: #fff;
        cursor: pointer;
        background: transparent;
        border-radius: 100%;
        padding: 4px;
        transition: all 200ms ease;
    }

    .ba-top-alert > .ba-top-alert-close:hover {
        background: #0001;
    }
`;

export default NumberDisconnectedAlert;